import React, { useState } from "react";
import { Form, Input, Button, Divider } from "antd";
import RequestSuccess from "./RequestSuccess";
import { SicunetIcon } from "../../../global/components/Icons/Sicunet";
import { useNavigate } from "react-router-dom";

const RequestUserForm = () => {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = useState(false);

  const handleFinish = (values) => {
    if (values.email && values.phone && values.message && values.name) {
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 4000);
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-0 w-full">
      {/* Logo for mobile */}
      <div className="lg:hidden flex justify-center mb-10">
        <SicunetIcon onClick={() => navigate("/")} />
      </div>

      <div className="w-full max-w-xl mx-auto bg-[#F5FAFF] px-8 sm:px-8 py-10 mt-18 rounded-md ">
        {!showSuccess ? (
          <>
            <h2 className="text-2xl font-semibold text-[#0D0D0D] text-center lg:text-left mb-6">
              See Sicunet in Action
            </h2>

            <Divider className="my-6" />

            <Form
              layout="vertical"
              onFinish={handleFinish}
              requiredMark={false}
              validateTrigger="onBlur"
              className="space-y-4"
            >
              {/* Email */}
              <Form.Item
                label="Company Email"
                name="email"
                rules={[
                  { required: true, message: "Please input your email!" },
                ]}
              >
                <Input
                  placeholder="example@company.com"
                  size="large"
                  aria-label="Company Email"
                />
              </Form.Item>

              {/* Name and Phone */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please input your name!" },
                  ]}
                >
                  <Input placeholder="Mike Shaw" size="large" />
                </Form.Item>

                <Form.Item
                  label="Phone"
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: "Please input your phone number!",
                    },
                  ]}
                >
                  <Input placeholder="+16105579129" size="large" />
                </Form.Item>
              </div>

              {/* Message */}
              <Form.Item
                label="Message"
                name="message"
                rules={[{ required: true, message: "Please leave a message!" }]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Leave us a message..."
                  className="resize-none"
                />
              </Form.Item>

              {/* Submit Button */}
              <Form.Item className="text-center justify-center items-center mt-8">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="bg-[#007AFC] hover:bg-[#005bb5] text-white px-8 py-2 rounded-full text-[16px] font-medium"
                >
                  Request a Demo
                </Button>
              </Form.Item>
            </Form>

            <Divider className="my-6" />

            {/* Terms */}
            <p className="text-xs text-center text-gray-500">
              By clicking <strong>"Request a Demo"</strong>, you agree to our{" "}
              <a href="#" className="text-blue-500 hover:underline">
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="/privacypolicy"
                className="text-blue-500 hover:underline"
              >
                Privacy Policy
              </a>
              .
            </p>
          </>
        ) : (
          <RequestSuccess />
        )}
      </div>
    </div>
  );
};

export default RequestUserForm;
